import styled from 'styled-components';
import { MOBILE_STICKY_OFFSET } from '../../../constants';
import { Media } from '../../../theme/Media';
import Typography from '../../Typography';
export const Wrapper = styled.div `
  position: sticky;
  top: 0px;
  z-index: 9;
  margin-bottom: 24px;

  @media ${Media.mdMax} {
    top: ${MOBILE_STICKY_OFFSET}px;
  }

  @media ${Media.xsMax} {
    margin-bottom: 8px;
  }
`;
export const InnerWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  background-color: ${({ theme }) => theme.colors.grey00_1};
  padding: 24px;
  min-height: 84px;
  box-shadow: inset 0 -1px 0 0 ${({ theme }) => theme.colors.grey10_1};

  & ${Typography.Headline} {
    align-self: flex-start;
    margin: 0;
  }

  @media ${Media.xsMax} {
    min-height: 58px;
    padding: 12px;
    flex-wrap: wrap;
    gap: 12px;
  }
`;
export const ActionsWrapper = styled.div `
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 12px;
  min-height: 34px;

  @media ${Media.xsMax} {
    width: 100%;
    justify-content: flex-end;
  }
`;
export const TabsWrapper = styled.div `
  background-color: ${({ theme }) => theme.colors.grey00_1};
  box-shadow: inset 0 -1px 0 0 ${({ theme }) => theme.colors.grey10_1};
  overflow-x: auto;

  @media ${Media.smMin} {
    padding: 0 16px;
  }
`;
export const SubTitleWrapper = styled.div `
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  min-height: 28px;
  flex-wrap: wrap;
`;
export const TitleWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
  word-break: break-word;
  color: ${({ theme }) => theme.colors.black_1};
`;
